import { render } from "./DiscordBot.vue?vue&type=template&id=503ceb15&scoped=true"
import script from "./DiscordBot.vue?vue&type=script&lang=js"
export * from "./DiscordBot.vue?vue&type=script&lang=js"

import "./DiscordBot.vue?vue&type=style&index=0&id=503ceb15&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503ceb15"]])

export default __exports__